'use strict';

(function () {
  var _controller = 'newReservation.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'router.resource', 'reservation.resource', '$q', 'event.resource', '$timeout'];
  function controller($scope, routerResource, reservationResource, $q, eventResource, $timeout) {
    //// Methods
    $scope.focus = focus;
    $scope.eventResource = eventResource;
    $scope.setStep = setStep;
    $scope.nextStep = nextStep;
    $scope.preReservation = preReservation;
    $scope.send = send;
    $scope.totalPrice = totalPrice;
    $scope.remainingPersons = remainingPersons;
    $scope.plusCount = plusCount;
    $scope.minusCount = minusCount;
    $scope.close = function(){
      appNavigator.popPage();
      onClose();
    };

    //// VARS
    var now = moment();
    var maxDate = now.clone().add(30, 'days').toDate();
    /// Deshabilito reservas pagas porque trae un problema en cerro
    var steps = ['router', 'slots', 'day', 'date', 'price', 'telephone', 'comment']
    $scope.reservation = { _controller: _controller };

    /// Esta bandera se usa para ponerla en el queryString y que la vista parezca una página aislada a la app
    /// Sería para usar la app solo como reserva, embeber en un sitio o armar un link
    $scope.reservationOnly = window.queryStrings.reservationOnly;
    $scope.step = steps[0];
    $scope.payConfig = null; // ESTA VARIABLE SE SETEA POR FRONTEND, BUSCAR EN JADE DE ESTA VISTA
    routerResource.query({ _controller: _controller }, function (routers) {
      $scope.routers = routers.filter(function(f){return !f.hidden});
      getEvent();
    });
    var slots, router;
    var onClose = appNavigator.topPage.data && appNavigator.topPage.data.onClose;
    var eventId = window.queryStrings.event;
    var routerId = window.queryStrings.reservationRouter;

    // WATCHERS
    $scope.$on('$destroy', onDestroy)
    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    $scope.$watch('reservation.router', function (oldval, newval) {
      if (oldval === newval) return;
      if (!$scope.reservation.router) return;
      $q.all([
        routerResource.get({ _id: $scope.reservation.router, _controller: _controller }).$promise,
        reservationResource.query({ router: $scope.reservation.router, event: eventId, maxDate: maxDate, _controller: _controller }).$promise
      ]).then(function (results) {
        router = results[0];
        $scope.router = router;
        var reservations = results[1];
        if (!router.reservationConfig) return slots = [];
        slots = reservationUtils.computeReservationSlots(moment().add(router.reservationConfig.disallowReservationsBefore, 'milliseconds'), maxDate, router.reservationConfig, router.utcOffset, eventId);
        reservations.forEach(function (reservation) {
          if (typeof reservation.date.getTime !== 'function') reservation.date = new Date(reservation.date);
          var slot = slots.find(function (f) { return f.start <= reservation.date && reservation.date <= f.end });
          if (slot) slot.maxReservations -= reservation.slots;
        })
      })
    });

    $scope.$watch('reservation.slots', function (newVal, oldVal) {
      if (newVal === oldVal || !newVal) return;
      $scope.dispDays = [];
      for (var mark = now.clone().utcOffset(router.utcOffset).set({ hours: 0, minutes: 0, seconds: 0, milliseconds: 0 }); mark < maxDate; mark.add(1, 'day')) {
        var midnight = mark.clone().set({ hours: 23, minutes: 59, seconds: 59, milliseconds: 999 });
        var day = {
          date: mark.toDate(),
          availableSlots: slots.filter(function (slot) { return slot.maxReservations - newVal >= 0 && slot.start <= midnight && slot.end >= mark }),
          midnight: midnight
        }
        if (day.availableSlots.length) $scope.dispDays.push(day);
      }
    })

    $scope.$watch('reservation.day', function (newVal, oldVal) {
      if (newVal === oldVal || !newVal) return;
      $scope.hours = [];
      var min = moment().add(router.reservationConfig.disallowReservationsBefore, 'milliseconds');
      var start = Math.min.apply(null, newVal.availableSlots.map(function (m) { return m.start }));
      if (start < min) start = min;
      else if (start < newVal.date) start = newVal.date;
      var end = Math.max.apply(null, newVal.availableSlots.map(function (m) { return m.end }));
      if (end > newVal.midnight) end = newVal.midnight;
      start = moment(start);
      end = moment(end);
      for (start.set({ minutes: Math.ceil(start.minutes() / 30) * 30, seconds: 0, milliseconds: 0 }); start < end && start < newVal.midnight; start.add(30, 'minutes')) {
        var avSlot = newVal.availableSlots.find(function (f) { return f.start <= start && start <= f.end });
        if (avSlot){
          if (avSlot.payConfig && avSlot.payConfig.options) avSlot.payConfig.options.forEach(function (f) { f.count = 0 })
          $scope.hours.push({
            ts: start.toDate(),
            payConfig: avSlot.payConfig
          });
        }
      }
      $scope.hours.sort(function (a, b) { return a.ts - b.ts });
    })


    // INIT
    setTimeout(function () {
      removeQueryString('reservationRouter')
      removeQueryString('reservation')
    }, 1000)
    if (routerId) $timeout(function () { $scope.nextStep(routerId); }, 100)



    ///////////////////////////

    function focus(cls) {
      var el = document.querySelector('.' + cls);
      if (!el) return;
      el.focus();
    }

    function getEvent() {
      if (eventId) {
        eventResource.detail({ _id: eventId, _controller: 'newReservation' }, function (e) {
          if (!e || !e.routers) {
            ons.notification.toast(i18next.t('Evento no disponible'), { timeout: 1500 })
            return $timeout(function () {
              removeQueryString('event');
              appNavigator.replacePage('home/home.jade');
            }, 2000)
          }
          $scope.event = e;
          $scope.routers = $scope.routers.filter(function (r) {
            return e.routers.filter(function (r1) { return r1 === r._id }).length
          })
        })
      }
    }

    function removeQueryString(queryString) {
      delete window.queryStrings[queryString];
    }


    function nextStep(value) {
      $scope.reservation[$scope.step] = value;
      var ix = steps.indexOf($scope.step);
      if (ix === steps.length - 1) return send()
      /// SALTAR PAGO
      if ($scope.step === 'date' && (!$scope.reservation.payConfig || $scope.reservation.payConfig.type === 'FREE')) ix++; /// Esto salta el pago si no hay que pagar
      $scope.step = steps[ix + 1];
    }
    function setStep(step) {
      for (var i = steps.indexOf(step) + 1; i < steps.length; i++) $scope.reservation[steps[i]] = null;
      $scope.step = step;
    }


    function send() {
      if (!$scope.$root.profile._id) return appNavigator.pushPage('login/login.jade', {
        data: {
          onClose: doReservation,
          allowAnonymous: true,
          overwriteText: i18next.t('Para completar la reserva por favor inicie sesión')
        }
      });
      doReservation();
    }

    function preReservation() {
      appNavigator.pushPage('reservations/preReservation/preReservation.jade', { data: { router: $scope.router._id } });
    }

    function doReservation(registration) {
      var request = angular.copy($scope.reservation);
      if (!$scope.$root.profile._id) {
        if (!registration || !registration.email) throw new PentaError('No hay información de perfil para realizar la reserva.')
        request.email = registration.email;
      }
      else request.email = $scope.$root.profile.email;
      if (eventId) request.event = eventId;

      request.extraData = { motive: 'Personas' }; // TODO: Scar esto en la version final
      reservationResource.doReservation(request, function (newRes) {
        /// Acá se borraba el evento del querystring
        removeQueryString('event');
        if (newRes.price)
          appNavigator.pushPage('mercadoPagoByApi/mercadoPagoByApi.jade', {
            data: {
              comment: i18next.t('El resumen de tu operación llegará al email con el cual hiciste la reserva o compra'),
              amount: newRes.price,
              extraData: {
                type: 'RESERVATION',
                email: request.email,
                reservation: newRes._id,
              },
              onClose: _onClose
            }
          });
        else _onClose();

        function _onClose() {
          $scope.resDone = true;
          $timeout(function () {
            $scope.resDone = false;
            if (window.queryStrings.reservationOnly) return resetProcess();
            appNavigator.popPage({ callback: onClose })
          }, 5000)
        }
      }, function (err) {
        if (err && err.message === '7005') setStep('router');
      })
    }

    function resetProcess() {
      $scope.reservation = { _controller: _controller };
      $scope.step = steps[0];
    }


    function totalPrice(payConfig) {
      if (!payConfig || !payConfig.options) return;
      var tp = 0;
      payConfig.options.forEach(function (c) {
        tp += c.price * c.count;
      })
      return tp;
    }

    function remainingPersons(payConfig) {
      if (!payConfig || !payConfig.options) return;
      var tp = $scope.reservation.slots;
      payConfig.options.forEach(function (c) {
        tp -= c.count;
      })
      return tp;
    }

    function plusCount(payConfig, option) {
      if (remainingPersons(payConfig) < 1) return;
      option.count++;
    }

    function minusCount(payConfig, option) {
      if (option.count <= 0) return;
      option.count--;
    }


    ///// FIN FUNCIONES CONTROLLER
  }
})();

